import BaseAPI from '@/apis/base/baseApi';
import commonFn from '@/commons/commonFunction';
import { MSEnum } from '@/commons/enumeration';
import store from '@/stores/store';
class FileAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'File';
  controllerName = 'File';

  getJson(fileName) {
    let request = {
      url: [this.getAPIUrl(), 'json', fileName].join('/'),
    };

    return this.getAsync(request);
  }

  /**
   * lấy link gọi download file
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   */
  getDownloadLink(type, file, name) {
    let url = [this.getAPIUrl(), 'download', type.toString()];
    if (file) {
      let tenantCode = store.state.context.User.TenantCode;
      if (tenantCode) {
        url.push(tenantCode);
      }
      url.push(file);
      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * lấy link gọi preview file
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} tenant :Dữ liệu công ty nào
   */
  getPreviewLink(type, file, name, appCode) {
    let url = [this.getAPIUrl(), 'preview', type.toString()];
    if (file) {
      let tenantCode = store.state.context.User.TenantCode;
      if (tenantCode) {
        url.push(tenantCode);
      }
      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} tenant :Dữ liệu công ty nào
   */
  getFileLink(type, file, name, appCode) {
    let url = [this.getAPIUrl(), type.toString()];
    if (file) {
      let tenantCode = store.state.context.User.TenantCode;
      if (tenantCode) {
        url.push(tenantCode);
      }
      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Upload file
   * @param {*} file : File upload
   * @param {*} type : Loại file
   */
  upload(file, type) {
    let data = new FormData();
    data.append('file', file);
    if (type) {
      data.append('type', type);
    }

    let request = {
      url: this.getAPIUrl(),
      data: data,
    };

    return this.postAsync(request);
  }

  /**
   * Upload nhiều file
   * @param {*} files : File upload
   * @param {*} type : Loại file
   */
  async uploads(files, type) {
    let data = new FormData();
    files.forEach((file) => {
      data.append('file', file, file.name);
    });

    let request = {
      url: this.getAPIUrl() + `/multi?type=${type}`,
      data: data
    };

    return await this.postAsync(request);
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} name : tên file server
   * @param {*} width : độ rộng ảnh
   * @param {*} height : chiều dài ảnh
   * @param {*} quantity : độ phân giải
   */
  getImageLink(type, name, width, height, appCode, quantity) {
    let url = [this.getAPIUrl(), 'image', type];
    if (name) {
      url.push(name);
    }
    if (width) {
      url.push(width);
    }
    if (height) {
      url.push(height);
    }
    if (appCode) {
      url.push(appCode);
    }

    if (quantity) {
      url.push(quantity);
    }

    return url.join('/');
  }

  /**
   * kiểm tra file name có tồn tại trong temp server chưa?
   * @param {*} name 
   * @returns 
   * created by lkphuc 02.03.2023
   */
  async checkExistTempFile(name) {
    let url = [this.getAPIUrl(), 'check-temp', name].join('/');
    let request = {
      url: url,
      transformResponse: (res) => {
        return res;
      }
    };
    return await this.getAsync(request);
  }

  /**
   * Preview file
   * @param {*} name 
   * @returns 
   */
  async previewFile(param) {
    let url = [this.getAPIUrl(), 'preview', param?.type, param?.fileID, param?.fileName].join('/');

    let request = {
      url: url,
      transformResponse: (res) => {
        return res;
      }
    };

    return await this.getAsync(request);
  }

  /**
   * Download file tu url
   * @param {*} fileUrl 
   * @param {*} fileName 
   * @returns 
   */
  downloadFromUrl(fileUrl, fileName) {
    let url = [this.getAPIUrl(), "downloadFromUrl?"];
    var params = {
      fileUrl: fileUrl,
      name: fileName,
    };
    let rootURL = url.join("/");
    let queryURL = commonFn.objectToQueryString(params);
    
    return rootURL + queryURL;
  }
}

export default new FileAPI();
